<template>
    <el-dialog title="Changer les titres" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formTitle" ref="form" :model="form">
            <div class="row">
                <el-form-item prop="prefixe" class="col-lg-5">
                    <el-input placeholder="Prefixe" v-model="form.prefixe"></el-input>
                </el-form-item>
                <el-form-item prop="suffixe" class="col-lg-5">
                    <el-input placeholder="Suffixe" v-model="form.suffixe"></el-input>
                </el-form-item>
            </div>
            <div class="row">
                <el-form-item prop="search" class="col-lg-5">
                    <el-input placeholder="Rechercher" v-model="form.search"></el-input>
                </el-form-item>
                <el-form-item prop="replace" class="col-lg-5">
                    <el-input placeholder="Remplacer" v-model="form.replace"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                prefixe: null,
                suffixe: null,
                search: null,
                replace: null
            }
        }
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            if (
                this.form.prefixe &&
                this.form.prefixe.indexOf(' ') != -1
            ) {
                var regex = new RegExp(/\s/gi);
                this.form.prefixe = this.form.prefixe.replace(
                    regex,
                    '&nbsp;'
                );
            }
            if (
                this.form.suffixe &&
                this.form.suffixe.indexOf(' ') != -1
            ) {
                var regex = new RegExp(/\s/gi);
                this.form.suffixe = this.form.suffixe.replace(
                    regex,
                    '&nbsp;'
                );
            }

            var datas = {
                products,
                datas: this.form,
                mode: 'title'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
}
</script>
